import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const satelliteAccountSelector = ({ satelliteAccount }: ReducerState) => satelliteAccount;
export const satelliteAccountLoadingSelector = createSelector(
  satelliteAccountSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
